import React from 'react';
import { Link } from 'react-router-dom';
import { DashboardShell, StatCards } from './DashboardShared';

const MemberTemplate = ({ data }) => {
  const req = data.latest_request;

  return (
    <DashboardShell
      title={`${data.company.name} — Welcome`}
      subtitle="Apply for a role to unlock your company dashboard"
      data={data}
    >
      <StatCards
        items={[
          { label: 'Profile completeness', value: `${data.profile_completeness ?? 0}%` },
        ]}
      />

      <section className="cd-panel">
        <h2 className="cd-panel-title">Get started</h2>
        <p className="cd-subtitle" style={{ marginBottom: '1rem' }}>
          Request a company role to access commissions, wallet features, and role-specific tools.
        </p>
        <div className="cd-member-actions">
          <Link to="/role_selection" className="cd-btn-primary">
            Apply for a role
          </Link>
          <Link to="/role-requests" className="cd-btn-secondary">
            View request history
          </Link>
          <Link to="/profile" className="cd-btn-secondary">
            Complete profile
          </Link>
        </div>
      </section>

      {req && (
        <section className="cd-panel">
          <h2 className="cd-panel-title">Latest role request</h2>
          <p>
            <strong>{req.role}</strong> at {req.company} —{' '}
            <span style={{ textTransform: 'capitalize' }}>{req.status}</span>
          </p>
          {req.created_at && (
            <p className="cd-stat-hint">Submitted {req.created_at.split(' ')[0]}</p>
          )}
        </section>
      )}
    </DashboardShell>
  );
};

export default MemberTemplate;
